import { call, put, takeLatest } from "redux-saga/effects";

import { sessionApi } from "../../services/api/session.api";
import {
  Session,
  SessionStatus,
  ValidateSessionSuccessPayload,
} from "../../types/session.definition";
import { clearPersistedPinLock } from "../../utils/pin-lock-utils";
import { removeMedecine360SessionTokenFromStorage } from "../../utils/session-utils";
import {
  clearSession,
  getSessionFailure,
  getSessionRequest,
  getSessionSuccess,
  requestTerminateSessionRequest,
  validateSessionFailure,
  validateSessionRequest,
  validateSessionSuccess,
} from "../reducers/sessionSlice";

export function* validateSessionSaga() {
  try {
    const response: ValidateSessionSuccessPayload = yield call(
      sessionApi.validateSession
    );
    yield put(
      validateSessionSuccess({
        ...response,
        sessionStatus: SessionStatus.VALID_SESSION,
      })
    );
    removeMedecine360SessionTokenFromStorage();
    yield put(getSessionRequest());
  } catch (error) {
    const errorMessage =
      error instanceof Error ? error.message : "Failed to validate session";
    yield put(validateSessionFailure(errorMessage));
  }
}

export function* getSessionSaga() {
  try {
    const session: Session = yield call(sessionApi.getSession);
    yield put(getSessionSuccess(session));
  } catch (error) {
    // Just update the session reducer state
    const errorMessage =
      error instanceof Error ? error.message : "Failed to get session";
    yield put(getSessionFailure(errorMessage));
  }
}

export function* requestTerminateSessionSaga() {
  // The next sign-in must not start locked.
  clearPersistedPinLock();
  try {
    yield call(sessionApi.terminateSession);
    yield put(clearSession());
  } catch (error) {
    // Log the error for debugging purposes
    console.error("Error terminating session:", error);
    // No need to update UI state since this is typically called during logout
  }
}

export function* watchSession() {
  yield takeLatest(validateSessionRequest.type, validateSessionSaga);
  yield takeLatest(getSessionRequest.type, getSessionSaga);
  yield takeLatest(
    requestTerminateSessionRequest.type,
    requestTerminateSessionSaga
  );
}
